// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-icon[data-v-223d8387]{position:absolute;right:5px;top:5px}`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":"AAEA,+BACC,iBAAA,CACA,SAAA,CACA,OAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
